// extracted by mini-css-extract-plugin
module.exports = {"analytics":"yn69p","inner":"dYrYm","item":"Ty34x"};